(() => {
 'use strict';
 // The global menu survives home-section replacements in the Theme Editor.
 if (window.yndEditorialInitialized) return;
 window.yndEditorialInitialized = true;
 const header = document.getElementById('header');
 const menuButton = document.getElementById('menu-toggle');
 const menu = document.getElementById('menu');
 const backdrop = document.getElementById('menu-backdrop');
 let activeFilm = null;
 let media = null;
 const syncHero = () => media?.sync();
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 const dataSaving = Boolean(navigator.connection?.saveData);
 document.addEventListener('click', event => {
  const link = event.target.closest?.('[data-back-to-top]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  window.scrollTo({top:0, behavior:reduced.matches ? 'instant' : 'smooth'});
  header?.querySelector('.wordmark')?.focus({preventScroll:true});
 });
 // Keep the native hero hash target exactly below the measured fixed header.
 const alignHeroTarget = () => {
  const target = document.getElementById('occasions');
  if (!target || !header) return;
  const scrollPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
  target.style.scrollMarginTop = `${header.getBoundingClientRect().height - scrollPadding}px`;
 };
 alignHeroTarget();
 window.addEventListener('resize', alignHeroTarget, {passive:true});
 document.addEventListener('shopify:section:load', alignHeroTarget);
 document.addEventListener('click', event => {
  const down = event.target.closest?.('.hero-down[href="#occasions"]');
  if (down && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
   const target = document.getElementById('occasions');
   if (!target) return;
   event.preventDefault();
   const top = target.getBoundingClientRect().top + window.scrollY;
   target.focus({preventScroll:true});
   window.scrollTo({top, behavior:reduced.matches ? 'instant' : 'smooth'});
   return;
  }
  if (event.target.closest?.('.hero-copy a[href="#occasions"]')) alignHeroTarget();
 });
 const background = () => [document.getElementById('main'), document.querySelector('.footer'), header.querySelector('.wordmark'), header.querySelector('.header-actions')].filter(Boolean);
 const desktopMenu = window.matchMedia('(min-width: 1001px)');
 const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
 let hoverOpenTimer = null;
 let hoverCloseTimer = null;
 let hoverOwnsMenu = false;
 let menuNavigationPending = false;
 function clearMenuHoverTimers() {
  window.clearTimeout(hoverOpenTimer);
  window.clearTimeout(hoverCloseTimer);
  hoverOpenTimer = hoverCloseTimer = null;
 }
 const canHoverMenu = event => desktopMenu.matches && hoverPointer.matches && event.pointerType !== 'touch' && !menuNavigationPending;
 const menuImageLoads = new WeakMap();
 const menuRoot = menu.querySelector('[data-menu-root]');
 const menuPanes = [...menu.querySelectorAll('[data-menu-pane]')];
 const menuBack = menu.querySelector('[data-menu-back]');
 const menuContext = menu.querySelector('[data-menu-context]');
 menuContext.dataset.rootLabel = menuContext.textContent;
 let activeMenuSection = '';
 let menuOpen = false;
 let menuOpener = menuButton;
 const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 40 || document.body.classList.contains('ynd-inner-page'));
 const syncScroll = () => {
  const locked = menuOpen || Boolean(document.querySelector('dialog[open]'));
  document.documentElement.classList.toggle('ynd-overlay-is-open', locked);
  document.body.classList.toggle('no-scroll', locked);
 };
 function focusableMenuItems() {
  return [menuButton, ...header.querySelectorAll('.desktop-nav a, .desktop-nav button'), ...menu.querySelectorAll('button, a')].filter(element => !element.closest('[hidden]') && !element.closest('[inert]') && element.getClientRects().length && !element.disabled);
 }
 function warmMenuPane(section, priority = 'low') {
  if (!desktopMenu.matches) return;
  const pane = menuPanes.find(element => element.dataset.menuPane === section);
  const image = pane?.querySelector('.ynd-menu-editorial img');
  if (!image) return;
  if (priority === 'high') image.fetchPriority = 'high';
  if (menuImageLoads.has(image)) return menuImageLoads.get(image);
  image.loading = 'eager';
  const ready = image.decode ? image.decode().catch(() => {}) : Promise.resolve();
  menuImageLoads.set(image, ready);
  return ready;
 }
 const canWarmMenu = () => desktopMenu.matches && !dataSaving && !/(^|-)2g$/.test(navigator.connection?.effectiveType || '') && !document.hidden;
 const scheduleBackgroundWarm = callback => {
  if ('requestIdleCallback' in window) window.requestIdleCallback(callback, {timeout:2500});
  else window.setTimeout(callback, 1500);
 };
 function warmDefaultMenu(index = 0) {
  if (!canWarmMenu() || index >= menuPanes.length) return;
  const ready = warmMenuPane(menuPanes[index].dataset.menuPane);
  Promise.resolve(ready).then(() => {
   if (index + 1 < menuPanes.length && canWarmMenu()) scheduleBackgroundWarm(() => warmDefaultMenu(index + 1));
  });
 }
 const scheduleMenuWarm = () => {
  const hero = document.getElementById('hero-video');
  // Explicit menu interactions still load immediately; speculative images wait for the film.
  if (hero && hero.paused && !reduced.matches) {
   hero.addEventListener('playing', () => scheduleBackgroundWarm(() => warmDefaultMenu()), {once:true});
  } else scheduleBackgroundWarm(() => warmDefaultMenu());
 };
 if (document.readyState === 'complete') scheduleMenuWarm();
 else window.addEventListener('load', scheduleMenuWarm, {once:true});
 [menuButton, ...document.querySelectorAll('[data-open-menu]')].forEach(button => {
  const warm = () => warmMenuPane(button.dataset.openMenu || 'shop');
  button.addEventListener('pointerenter', warm, {passive:true});
  button.addEventListener('focus', warm);
  button.addEventListener('pointerdown', warm, {passive:true});
 });
 function showMenuPane(section, moveFocus = true) {
  warmMenuPane(section, 'high');
  activeMenuSection = section;
  const pane = menuPanes.find(element => element.dataset.menuPane === section);
  menuRoot.hidden = Boolean(pane);
  menuPanes.forEach(element => { element.hidden = element !== pane; });
  menuBack.hidden = !pane || desktopMenu.matches;
  menuContext.textContent = pane ? pane.dataset.menuLabel : menuContext.dataset.rootLabel;
  document.querySelectorAll('[data-open-menu], [data-menu-section]').forEach(button => button.setAttribute('aria-expanded', String(menuOpen && button.dataset.openMenu === section || menuOpen && button.dataset.menuSection === section)));
  menu.scrollTop = 0;
  if (moveFocus) {
   const target = desktopMenu.matches ? pane?.querySelector('a, button') : pane ? menuBack : menuRoot.querySelector('button, a');
   target?.focus({preventScroll:true});
  }
 }
 function setMenu(open, focusBack = true, section = desktopMenu.matches ? 'shop' : '', moveFocus = true) {
  clearMenuHoverTimers();
  hoverOwnsMenu = false;
  menuNavigationPending = false;
  if (open && !menuOpen) menuOpener = document.activeElement;
  menuOpen = open;
  header.classList.toggle('menu-open', open);
  menu.classList.toggle('is-open', open);
  menuButton.setAttribute('aria-expanded', String(open));
  menuButton.setAttribute('aria-label', open ? menuButton.dataset.closeLabel : menuButton.dataset.openLabel);
  menu.inert = !open;
  backdrop.hidden = !open;
  background().forEach(element => { element.inert = open; });
  if (open) { showMenuPane(section, moveFocus); if (activeFilm && !activeFilm.paused) activeFilm.pause(); }
  else document.querySelectorAll('[data-open-menu], [data-menu-section]').forEach(button => button.setAttribute('aria-expanded', 'false'));
  syncScroll(); syncHero();
  if (!open && focusBack) (menuOpener?.isConnected && menuOpener.getClientRects().length ? menuOpener : menuButton).focus({preventScroll:true});
 }
 document.addEventListener('ynd:overlay', () => { const hasDialog = Boolean(document.querySelector('dialog[open]')); if (hasDialog && menuOpen) setMenu(false, false); if (hasDialog && activeFilm && !activeFilm.paused) activeFilm.pause(); syncScroll(); syncHero(); });
 updateHeader();
 window.addEventListener('scroll', updateHeader, {passive:true});
 menuButton.addEventListener('click', () => setMenu(!menuOpen));
 document.querySelectorAll('[data-open-menu]').forEach(button => {
  button.addEventListener('click', () => {
   const samePane = menuOpen && activeMenuSection === button.dataset.openMenu;
   if (menuOpen && !samePane) menuOpener = button;
   setMenu(!samePane, true, button.dataset.openMenu);
  });
  button.addEventListener('keydown', event => {
   if (event.key === 'ArrowDown') { event.preventDefault(); setMenu(true, true, button.dataset.openMenu); }
  });
 });
 menu.querySelectorAll('[data-menu-section]').forEach(button => button.addEventListener('click', () => showMenuPane(button.dataset.menuSection)));
 menuBack.addEventListener('click', () => {
  const previousSection = activeMenuSection;
  showMenuPane('', false);
  menuRoot.querySelector(`[data-menu-section="${previousSection}"]`)?.focus({preventScroll:true});
 });
 // Leave a short bridge across the fixed-header/panel boundary. Only a menu
 // opened by hover auto-closes; click and keyboard retain their existing flow.
 const hoverTriggers = [...header.querySelectorAll('.desktop-nav [data-open-menu]')].filter(button => ['shop', 'occasions'].includes(button.dataset.openMenu));
 function leaveHoverMenu(event) {
  if (!canHoverMenu(event)) return;
  clearMenuHoverTimers();
  if (!hoverOwnsMenu || menu.contains(event.relatedTarget) || hoverTriggers.some(button => button.contains(event.relatedTarget))) return;
  hoverCloseTimer = window.setTimeout(() => {
   hoverCloseTimer = null;
   if (hoverOwnsMenu && !menuNavigationPending) setMenu(false, false);
  }, 220);
 }
 hoverTriggers.forEach(button => {
  button.addEventListener('pointerenter', event => {
   if (!canHoverMenu(event)) return;
   clearMenuHoverTimers();
   if (menuOpen && activeMenuSection === button.dataset.openMenu) return;
   hoverOpenTimer = window.setTimeout(() => {
    hoverOpenTimer = null;
    if (!canHoverMenu(event) || document.querySelector('dialog[open]')) return;
    setMenu(true, false, button.dataset.openMenu, false);
    menuOpener = button;
    hoverOwnsMenu = true;
   }, 100);
  });
  button.addEventListener('pointerleave', leaveHoverMenu);
 });
 menu.addEventListener('pointerenter', event => { if (canHoverMenu(event)) clearMenuHoverTimers(); });
 menu.addEventListener('pointerleave', leaveHoverMenu);
 // Keyboard focus inside the panel takes ownership from pointer hover.
 menu.addEventListener('focusin', () => { clearMenuHoverTimers(); hoverOwnsMenu = false; });
 const resetMenuHover = () => {
  clearMenuHoverTimers();
  if (menuOpen) setMenu(false);
 };
 desktopMenu.addEventListener('change', resetMenuHover);
 hoverPointer.addEventListener('change', () => {
  clearMenuHoverTimers();
  if (hoverOwnsMenu) setMenu(false, false);
 });
 window.addEventListener('pagehide', clearMenuHoverTimers);
 menu.querySelector('[data-close-menu]')?.addEventListener('click', () => setMenu(false));
 backdrop.addEventListener('click', () => setMenu(false));
 window.addEventListener('pageshow', event => {
  clearMenuHoverTimers();
  menuNavigationPending = false;
  if (!event.persisted) return;
  document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
  setMenu(false, false);
 });
 function followMenuLink(event) {
  const link = event.currentTarget;
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target.toLowerCase() !== '_self')) return;
  const targetURL = new URL(link.href, location.href);
  const sameDocument = targetURL.origin === location.origin && targetURL.pathname === location.pathname && targetURL.search === location.search;
  // Keep the outgoing frame still while the browser loads another document.
  // Closing here exposes the old page and changes its header before navigation.
  // The existing persisted pageshow handler unlocks it on Back/Forward restore.
  if (!sameDocument && /^https?:$/.test(targetURL.protocol)) {
   menuNavigationPending = true;
   clearMenuHoverTimers();
   return;
  }
  if (menuOpen) setMenu(false, false);
  if (sameDocument && targetURL.hash) {
   let targetId;
   try { targetId = decodeURIComponent(targetURL.hash.slice(1)); } catch { targetId = targetURL.hash.slice(1); }
   document.getElementById(targetId)?.focus({preventScroll:true});
  }
 }
 header.querySelectorAll('.desktop-nav a').forEach(link => link.addEventListener('click', followMenuLink));
 menu.querySelectorAll('a').forEach(link => link.addEventListener('click', followMenuLink));
 document.addEventListener('keydown', event => {
  if (!menuOpen) return;
  if (event.key === 'Escape') { event.preventDefault(); setMenu(false); return; }
  if (event.key === 'Tab') {
   const items = focusableMenuItems();
   const current = items.indexOf(document.activeElement);
   const next = current === -1 ? 0 : (current + (event.shiftKey ? -1 : 1) + items.length) % items.length;
   event.preventDefault(); items[next]?.focus();
  }
 });
 // Each media binding owns its listeners and observer, including pending play promises.
 function initializeMedia() {
  const nextHero = document.getElementById('hero-video');
  const nextFilm = document.getElementById('full-film');
  if (media && media.hero === nextHero && media.film === nextFilm) return;
  media?.dispose();
  media = null;
  activeFilm = nextFilm;
  if (!nextHero && !nextFilm) return;
  let destroyed = false;
  const cleanups = [];
  const listen = (target, type, callback, options) => {
   target.addEventListener(type, callback, options);
   cleanups.push(() => target.removeEventListener(type, callback, options));
  };
  let heroVisible = true;
  let manuallyPaused = false;
  let manuallyStarted = false;
  const filmSection = document.getElementById('film');
  const filmClose = document.getElementById('film-close');
  const filmStatus = document.getElementById('film-status');
  const film = document.getElementById('full-film');
  const filmPlay = document.getElementById('film-play');
  const hero = document.getElementById('hero-video');
  const heroPoster = document.querySelector('.hero-poster');
  let autoplayReady = !heroPoster;
  let autoplayScheduled = false;
  let autoplayIdle = null;
  let autoplayTimer = null;
  let decodeTimer = null;
  let posterWaitTimer = null;
  const motion = document.getElementById('motion-control');
  function syncMotion() {
   if (destroyed || !hero || !motion) return;
   motion.setAttribute('aria-label', hero.paused ? 'Play video' : 'Pause video');
   motion.dataset.paused = String(hero.paused);
  }
  function loadVideo(video) {
   const source = video.querySelector('source');
   if (source && !source.getAttribute('src') && source.dataset.src) { source.src = source.dataset.src; video.load(); }
  }
  function canPlayHero() {
   return !destroyed && (autoplayReady || manuallyStarted) && heroVisible && (!film || film.paused) && !document.hidden && !manuallyPaused && !reduced.matches && (!dataSaving || manuallyStarted);
  }
  function syncHero() {
   if (destroyed || !hero) return;
   if (canPlayHero()) {
    loadVideo(hero);
    // Opening or switching navigation/shopping/account overlays must not interrupt the film.
    if (hero.paused) hero.play().then(() => { if (!canPlayHero()) hero.pause(); }).catch(syncMotion);
   } else if (!hero.paused) hero.pause();
  }
  media = {hero, film, sync:syncHero, dispose() {
   destroyed = true;
   cleanups.forEach(cleanup => cleanup());
   hero?.pause();
   film?.pause();
  }};
  if (hero && motion) {
  if (heroPoster) {
   const releaseAutoplay = () => {
    if (destroyed || autoplayReady) return;
    autoplayReady = true;
    if (posterWaitTimer !== null) window.clearTimeout(posterWaitTimer);
    syncHero();
   };
   posterWaitTimer = window.setTimeout(releaseAutoplay, 3000);
   const afterPoster = () => {
    if (destroyed || autoplayReady || autoplayScheduled) return;
    autoplayScheduled = true;
    const schedule = () => {
     if (destroyed || autoplayReady) return;
     if (decodeTimer !== null) window.clearTimeout(decodeTimer);
     if (autoplayIdle !== null || autoplayTimer !== null) return;
     if ('requestIdleCallback' in window) autoplayIdle = window.requestIdleCallback(releaseAutoplay, {timeout:1200});
     else autoplayTimer = window.setTimeout(releaseAutoplay, 200);
    };
    decodeTimer = window.setTimeout(schedule, 1500);
    if (heroPoster.decode) heroPoster.decode().then(schedule, schedule);
    else schedule();
   };
   listen(heroPoster, 'load', afterPoster, {once:true});
   listen(heroPoster, 'error', afterPoster, {once:true});
   cleanups.push(() => {
    if (posterWaitTimer !== null) window.clearTimeout(posterWaitTimer);
    if (autoplayIdle !== null && 'cancelIdleCallback' in window) window.cancelIdleCallback(autoplayIdle);
    if (autoplayTimer !== null) window.clearTimeout(autoplayTimer);
    if (decodeTimer !== null) window.clearTimeout(decodeTimer);
   });
   if (heroPoster.complete) afterPoster();
  }
  listen(hero, 'playing', () => {
   if (!canPlayHero()) { hero.pause(); return; }
   hero.classList.add('ready'); syncMotion();
  });
  listen(hero, 'pause', syncMotion);
  listen(hero, 'error', () => { hero.classList.remove('ready'); syncMotion(); });
  listen(motion, 'click', () => {
   if (hero.paused) { manuallyPaused = false; manuallyStarted = true; }
   else manuallyPaused = true;
   syncHero();
  });
  listen(reduced, 'change', syncHero);
  listen(document, 'visibilitychange', syncHero);
  if ('IntersectionObserver' in window) {
   const observer = new IntersectionObserver(entries => { if (destroyed) return; heroVisible = entries[0].isIntersecting; syncHero(); }, {threshold:.1});
   observer.observe(hero.closest('.hero') || hero);
   cleanups.push(() => observer.disconnect());
  }
  }
  if (filmPlay && filmSection && film) {
  const filmCopy = filmSection.querySelector('.film-copy');
  const filmShade = filmSection.querySelector('.film-shade');
  const filmCaption = filmSection.querySelector('.film-caption');
  function showInlineFilm(show) {
   film.hidden = !show;
   filmClose.hidden = !show;
   filmCopy.hidden = show;
   filmShade.hidden = show;
   filmCaption.hidden = show;
   filmStatus.hidden = true;
   filmSection.classList.toggle('is-playing', show);
   if (!show) { film.pause(); filmPlay.focus({preventScroll:true}); }
  }
  listen(filmPlay, 'click', () => {
   showInlineFilm(true);
   loadVideo(film);
   film.focus({preventScroll:true});
   film.play().then(() => { if (destroyed) film.pause(); }).catch(() => { if (!destroyed) filmStatus.hidden = false; });
  });
  listen(filmClose, 'click', () => showInlineFilm(false));
  listen(film, 'play', () => { if (hero) hero.pause(); filmStatus.hidden = true; });
  listen(film, 'pause', syncHero);
  listen(film, 'ended', syncHero);
  listen(film, 'error', () => { filmStatus.hidden = false; });
  listen(document, 'visibilitychange', () => { if (document.hidden) film.pause(); });
  listen(window, 'pagehide', () => film.pause());
  }
  syncMotion(); syncHero();
 }
 document.addEventListener('shopify:section:unload', event => {
  if (!media || ![media.hero, media.film].some(element => element && (element === event.target || event.target.contains(element)))) return;
  media.dispose();
  media = null;
  activeFilm = null;
 });
 document.addEventListener('shopify:section:load', () => {
  initializeMedia();
  background().forEach(element => { element.inert = menuOpen; });
 });
 initializeMedia();
})();

